$(function(){

  window.Parsley.setLocale($('html').attr('lang'));

  if ($('form.parsley').length > 0){
    $('form.parsley').parsley();
  }

  if ($('img.unveil').length > 0) {
    $('img.unveil').unveil(250);
  }

  if ($('img.unveil-bg').length > 0){
    $("img.unveil-bg").unveil(250, function() {
      $(this).backgroundCover();
    });
  }

  /*
  ===============
  =====GOALS=====
  ===============
  */
  $("a[href^='tel']").on("click",function(){
    gtag('event', 'event_name', {
      'event_category':'telephone',
      'event_action':'click',
      'event_label':'click-telehpone',
      'value':'1'
    });
    gtag_report_conversion();
  });

  /*
  ===============
  ==Mobile Menu==
  ===============
  */
  $(".burger").on("click",function(){
    $(this).toggleClass("active");
    $("header#main-header nav#main-nav .nav").toggleClass("active");
  });
  $("li.with-sub,li.with-big-sub").on("click",function(){
    $(this).toggleClass("active");
  });

  /*
  ==========================
  ==Smooth Scroll function==
  ==========================
  */
  $('a[href*="#"]:not([href="#"])').on("click",function() {
    if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) +']');

      if (target.length) {
        $('html, body').animate({
          scrollTop: target.offset().top - $("header").outerHeight()
        }, 1000);

        return false;
      }
    }
  });

  /*
  ====================
  ==Open a modal box==
  ====================
  */
  var myModal = "";

  $(".modal-trigger").click(function(){
    myModal = $(this).attr("href");
    $(myModal).fadeIn("slow");
    $(".modal-overlay").fadeIn("slow");
  });

  $(".modal-footer .btn").click(function(){
    $(myModal).fadeOut("slow");
    $(".modal-overlay").fadeOut("slow");
  });

  /*
  ==========================================
  ==Recalling bg-cover to prevent glitches==
  ==========================================
  */
  $(window).resize(function(){
    $(".bg-cover").backgroundCover();
  });

  $(window).on('load',function() {
    $(".bg-cover").backgroundCover();
  });

  $(".bg-cover").backgroundCover();

  window.onfocus = function () {
    $(".bg-cover").backgroundCover();
  };

  window.onblur = function () {
    $(".bg-cover").backgroundCover();
  };
});

$(window).on("load",function(){
  /*
  ====================
  ====Fixed Header====
  ====================
  */
  var myHeight = $("header#main-header").outerHeight();
  $("#main-content").css("padding-top",myHeight);

  $(window).scroll(function () {
    if ($(window).scrollTop() >= 50) {
      $("header#main-header").addClass("fixed");
    }
    else{
      $("header#main-header").removeClass("fixed");
    }

    if ($(window).scrollTop() == 0) {
      setTimeout(function(){
        var myHeight = $("header#main-header").outerHeight();
        $("#main-content").css("padding-top",myHeight);
     }, 100)
      
    }
  });

  // Sweet alert
  $(".alert-available-soon").click(function(data){
    var textAlert = $(this).data("text-alert");
    Swal.fire({
      type: 'warning',
      text: textAlert,
    })
  });

});

$(window).resize(function(){
  var myHeight = $("header#main-header").outerHeight();
  $("#main-content").css("padding-top",myHeight);
});
